/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_No_Applications_TextInputs */

const en_candidate_no_applications_text = /** @type {(inputs: Candidate_No_Applications_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have not submitted any applications yet.`)
};

const de_candidate_no_applications_text = /** @type {(inputs: Candidate_No_Applications_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben noch keine Bewerbungen eingereicht.`)
};

/**
* | output |
* | --- |
* | "You have not submitted any applications yet." |
*
* @param {Candidate_No_Applications_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_no_applications_text = /** @type {((inputs?: Candidate_No_Applications_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_No_Applications_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_no_applications_text(inputs)
	return en_candidate_no_applications_text(inputs)
});